module.exports = __webpack_public_path__ + "static/media/comjoodoc_logo_claim.2ca276e2.png";